import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Typography, CssBaseline, Tabs, Tab, Box, Grid } from '@mui/material';
import UploadForm from './components/UploadForm';
import ResultsDisplay from './components/ResultsDisplay';
import TranscriptionsHistory from './components/TranscriptionsHistory';
import QueuePanel from './components/QueuePanel';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [results, setResults] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const handleResults = (newResults) => {
    setResults(newResults);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="app-container fade-in">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            align="center"
            className="gradient-text"
            sx={{
              fontWeight: 700,
              mb: 4,
              textShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            🎙️ Transcripción Inteligente de Audio
          </Typography>

          <Typography
            variant="h6"
            align="center"
            sx={{
              mb: 4,
              color: 'rgba(0,0,0,0.7)',
              fontWeight: 400
            }}
          >
            Convierte audio en texto con IA avanzada, timestamps precisos y resúmenes inteligentes
          </Typography>

          {/* Navigation Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
            <Tabs value={activeTab} onChange={handleTabChange} aria-label="navigation tabs">
              <Tab label="📤 Nueva Transcripción" />
              <Tab label="📚 Historial" />
              <Tab label="⏳ Cola de Procesamiento" />
            </Tabs>
          </Box>

          {/* Tab Content */}
          <Box sx={{ mt: 2 }}>
            {activeTab === 0 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <UploadForm onResults={handleResults} />
                  <ResultsDisplay results={results} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <QueuePanel />
                </Grid>
              </Grid>
            )}

            {activeTab === 1 && (
              <TranscriptionsHistory />
            )}

            {activeTab === 2 && (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <QueuePanel />
              </Box>
            )}
          </Box>
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default App;